export default {"src":"/_next/static/media/office-space.mono.1d2540bc.svg","height":333,"width":364,"blurWidth":0,"blurHeight":0};